import Vue from "vue";
import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchItems = async options => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options });
};

const fetchCourses = options => {
  const url = apiConstants.courses;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const fetchCourseTypes = options => {
  const url = apiConstants.courseTypes;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const fetchLocations = options => {
  const url = apiConstants.locations;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const fetchCourseCategories = options => {
  const url = apiConstants.courseCategories;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const fetchChildren = options => {
  const url = apiConstants.children;
  return Vue.axios.get(url, { params: options }).then(res => res.data);
};

const saveCourseWeek = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.courseWeek + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.courseWeek;
    return await apiPost(url, { ...data }, validator);
  }
};

const deleteCourseWeek = async id => {
  const url = apiConstants.courseWeek;
  return await apiDelete(url + "/" + id);
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const copyItem = async id => {
  let url = apiConstants.url + "/" + id + "/copy";
  return await apiPost(url);
};

const changeActiveItem = async id => {
  let url = apiConstants.url + "/" + id + "/changeActive";
  return await apiPost(url);
};

const sendRegistration = async (id, data, validator) => {
  let url = apiConstants.sendRegistration + "/" + id + "/admin";
  return await apiPost(url, { ...data }, validator);
};

const clearWaitingList = async id => {
  let url = apiConstants.emtyWaitingQueue + "/" + id + "/admin";
  return await apiPost(url);
};

export {
  fetchItems,
  saveItem,
  deleteItem,
  fetchItem,
  fetchCourses,
  fetchCourseTypes,
  fetchLocations,
  fetchCourseCategories,
  saveCourseWeek,
  deleteCourseWeek,
  fetchChildren,
  sendRegistration,
  changeActiveItem,
  copyItem,
  clearWaitingList
};
